import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Button, AddIcon } from '@occc/ui-design-system';
import { useAppLayoutContextConsumer, Page } from '@occc-app/design-system';
import { useIsUserPermittedTo, Feature } from '@occc/utils-access-control';
import { AwardCatalogTableContainer } from './AwardCatalogTableContainer';
import { routeCreator, getAwardListPageHeaderLinks } from '../utils';
import { messages } from '../messages';

const AwardCatalogListPage = () => {
  const links = useMemo(() => getAwardListPageHeaderLinks(), []);
  useAppLayoutContextConsumer(links);

  const isUserPermittedToCreateAward = useIsUserPermittedTo(Feature.AWARD_CREATE);

  return (
    <Page
      browserTabTitle={messages.title}
      pageHeaderProps={{
        title: 'Award Catalog List',
      }}
      actions={
        isUserPermittedToCreateAward && (
          <Button
            color='secondary'
            variant='contained'
            component={Link}
            to={routeCreator.create()}
            startIcon={<AddIcon />}
            role='button'
          >
            {messages.createButton}
          </Button>
        )
      }
    >
      <AwardCatalogTableContainer />
    </Page>
  );
};

export default AwardCatalogListPage;
